export const CHANNEL_MEZZO_DEVICES = 'MezzoTool::MezzoDevicesChannel'
export const CHANNEL_PROGRAM_OPTIONS = 'MezzoTool::ProgramOptionsChannel'
export const CHANNEL_COMMANDS = 'MezzoTool::CommandsChannel'
export const CHANNEL_FACTORY_DEVICES = 'MezzoTool::FactoryDevicesChannel'
export const CHANNEL_RESTORE_UNIT_USERS = 'MezzoTool::RestoreUnitUsersChannel'
export const CHANNEL_BINARY_COMMANDS = 'MezzoTool::BinaryCommandsChannel'
export const FIRMWARE_CHANNEL = 'MezzoTool::FirmwareChannel'
